
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";

export const useProfileForm = () => {
  const validateUsername = (username: string) => {
    const regex = /^[a-zA-Z0-9_]+$/;
    if (!regex.test(username)) {
      return "Username can only contain letters, numbers, and underscores";
    }
    return null;
  };

  const handleUsernameChange = (username: string, setUsername: (value: string) => void) => {
    const newUsername = username.replace(/[^a-zA-Z0-9_]/g, '');
    setUsername(newUsername);
  };

  const updateProfile = async (
    userId: string,
    username: string,
    bio: string,
    avatarUrl: string,
    nationality: string,
    creatorTypes: string[]
  ) => {
    try {
      const usernameError = validateUsername(username);
      if (usernameError) {
        toast.error(usernameError);
        return;
      }

      const { error } = await supabase
        .from("profiles")
        .update({
          username,
          bio,
          avatar_url: avatarUrl,
          nationality,
          creator_type: creatorTypes,
          updated_at: new Date().toISOString(),
        })
        .eq('id', userId);

      if (error) {
        console.error("Profile update error:", error);
        toast.error("Error updating profile");
        return;
      }
      
      toast.success("Profile updated successfully");
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Error updating profile");
    }
  };

  return {
    validateUsername,
    handleUsernameChange,
    updateProfile,
  };
};
